import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import Header from '../../components/Header';
import Nav from '../../components/Nav';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { getSuppliers } from '../../redux/actions/supplier.action';
import axios from 'axios';
import { endpoint, endpointApi } from '../../utils';
import { setLoading } from '../../redux/actions/loader.action';
import { logout } from '../../redux/actions/auth.action';
import Paginate from '../../components/Paginate';

export default function SuppliersPage() {
    const jwt_access = localStorage.getItem('jwt_access');
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const suppliers = useSelector(state => state.suppliers);
    const { me } = useSelector(state => state.auth);

    const modalRef = useRef(null);
    const detailsModalRef = useRef(null);
    const fileRef = useRef(null);
    const [supplier, setSupplier] = useState(null);
    const [modal, setModal] = useState(null);
    const [actionModal, setActionModal] = useState(null);
    
    const [code, setCode] = useState("");
    const [photo, setPhoto] = useState("");
    const [type, setType] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [rcs, setRcs] = useState("");
    const [nif, setNif] = useState("");
    const [stat, setStat] = useState("");
    const [gender, setGender] = useState("");
    const [firstname, setFirstname] = useState("");
    const [lastname, setLastname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [address, setAddress] = useState("");
    const [zipcode, setZipcode] = useState("");
    const [city, setCity] = useState("");
    const [country, setCountry] = useState("");
    const [website, setWebsite] = useState("");
    const [isCodeTouched, setIsCodeTouched] = useState(false);
    const [isTypeTouched, setIsTypeTouched] = useState(false);
    const [isCompanyNameTouched, setIsCompanyNameTouched] = useState(false);
    const [isRcsTouched, setIsRcsTouched] = useState(false);
    const [isNifTouched, setIsNifTouched] = useState(false);
    const [isStatTouched, setIsStatTouched] = useState(false);
    const [isGenderTouched, setIsGenderTouched] = useState(false);
    const [isFirstnameTouched, setIsFirstnameTouched] = useState(false);
    const [isPhoneTouched, setIsPhoneTouched] = useState(false);
    const [isEmailTouched, setIsEmailTouched] = useState(false);
    const [isAddressTouched, setIsAddressTouched] = useState(false);
    const [isZipcodeTouched, setIsZipcodeTouched] = useState(false);
    const [isCityTouched, setIsCityTouched] = useState(false);
    const [isCountryTouched, setIsCountryTouched] = useState(false);
    const [isWebsiteTouched, setIsWebsiteTouched] = useState(false);
    const [errors, setErrors] = useState(null);

    useEffect(() => {
        dispatch(getSuppliers(location, navigate));
    }, [location, dispatch, navigate]);

    const handlePhotoChange = (e) => {
        const selectedPhoto = e.target.files[0];
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64String = reader.result;
            setPhoto(base64String);
        };
    
        if (selectedPhoto) {
            reader.readAsDataURL(selectedPhoto);
        }
    }

    const _close = useCallback(() => {
        setModal(null);
        setCode("");
        setType("");
        setCompanyName("");
        setRcs("");
        setNif("");
        setStat("");
        setGender("");
        setFirstname("");
        setLastname("");
        setPhone("");
        setEmail("");
        setAddress("");
        setZipcode("");
        setCity("");
        setCountry("");
        setWebsite("");
        setIsCodeTouched(false);
        setIsTypeTouched(false);
        setIsCompanyNameTouched(false);
        setIsRcsTouched(false);
        setIsNifTouched(false);
        setIsStatTouched(false);
        setIsGenderTouched(false);
        setIsFirstnameTouched(false)
        setIsPhoneTouched(false);
        setIsEmailTouched(false);
        setIsAddressTouched(false);
        setIsZipcodeTouched(false);
        setIsCityTouched(false);
        setIsCountryTouched(false);
        dispatch(setLoading(false));
        setErrors(null);

        if(fileRef.current)
            fileRef.current.value = null;
    
        setTimeout(() => {
          setSupplier(null);
        }, 200);
    }, [dispatch]);

    const close = useCallback((e) => {
        if(modalRef.current === e.target || detailsModalRef.current === e.target || e.target.classList.contains('_modal-close')){
          _close();
        }
    }, [_close]);

    useEffect(() => {
        document.addEventListener('click', close);
        return () => {
            document.removeEventListener('click', close);
        }
    }, [close]);

    const updateSupplier = (id) => {
        setSupplier(suppliers && suppliers.data && suppliers.data.data.find(e => e.id === id) ? suppliers.data.data.find(e => e.id === id) : null);
    }
    
    useEffect(() => {
        if(supplier){
          setCode(supplier.code ? supplier.code : "");
          setType(supplier.type ? supplier.type : "");
          setCompanyName(supplier.company_name ? supplier.company_name : "");
          setRcs(supplier.rcs ? supplier.rcs : "");
          setNif(supplier.nif ? supplier.nif : "");
          setStat(supplier.stat ? supplier.stat : "");
          setGender(supplier.gender ? supplier.gender : "");
          setFirstname(supplier.first_name ? supplier.first_name : "");
          setLastname(supplier.last_name ? supplier.last_name : "");
          setPhone(supplier.phone ? supplier.phone : "");
          setEmail(supplier.email ? supplier.email : "");
          setAddress(supplier.address ? supplier.address : "");
          setZipcode(supplier.zipcode ? supplier.zipcode : "");
          setCity(supplier.city ? supplier.city : "");
          setCountry(supplier.country ? supplier.country : "");
          setWebsite(supplier.website ? supplier.website : "");
        }
    }, [supplier]);

    useEffect(() => {
        if(modal){
            const $modals = document.querySelectorAll('._modal-content');
            $modals.forEach($modal => {
                $modal.scrollTop = 0;
            })
        }
    }, [modal]);
    
    const handleSubmit = async(e) => {
        e.preventDefault();
        dispatch(setLoading(true));
        setErrors(null);
        const data = new FormData(e.target);
        if("add" === modal){
            await axios.post(`${ endpointApi }suppliers`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${ jwt_access}`
                }
            }).then(({ data }) => {
                dispatch(getSuppliers(location, navigate));
                setSupplier(data);
                setModal('details');
                if(fileRef.current)
                    fileRef.current.value = null;
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }else{
            await axios.post(`${ endpointApi }suppliers/${ supplier.id }`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${ jwt_access}`
                }
            }).then(({ data }) => {
                dispatch(getSuppliers(location, navigate));
                setSupplier(data);
                setModal('details');
                if(fileRef.current)
                    fileRef.current.value = null;
            }).catch(err => {
                if(err.response.status === 401){
                    dispatch(logout(location.pathname + location.search, navigate));
                }else{
                    setErrors(err.response && err.response.data && err.response.data.errors ? err.response.data.errors : {error: err.response.data && err.response.data.message ? err.response.data.message : err.message});
                    const $modals = document.querySelectorAll('._modal-content');
                    $modals.forEach($modal => {
                        $modal.scrollTop = 0;
                    });
                }
            })
            .finally(() => {
                dispatch(setLoading(false));
            });
        }
    }

    useEffect(() => {
        const clickOutsideActionModal = (e) => {
            const $actionModals = document.querySelectorAll('.actions>ul');
            $actionModals.forEach($actionModal => {
                if($actionModal && !$actionModal.contains(e.target) && $actionModal.classList.contains('active')){
                    setActionModal(null);
                }
            });
        }
        document.addEventListener('click', clickOutsideActionModal);
        return () => {
            document.removeEventListener('click', clickOutsideActionModal);
        }
    }, []);

    useEffect(() => {
        if(!jwt_access){
            navigate('/login?redirect_to=' + location.pathname + location.search);
        }
    }, [location, navigate, jwt_access]);

    return (
        me &&
        <HelmetProvider>
            <Helmet>
                <title>Fournisseurs - Société Mikalo</title>
            </Helmet>
            
            <Header />

            <Nav />

            <main id="main">
                <div className='title d-flex justify-content-between'>
                    <h1>Fournisseurs</h1>
                    <button type='button' onClick={ () => {
                        setModal('add');
                    } } className='btn btn-primary'><i className='fa fa-plus'></i> Ajouter</button>
                </div>

                <div ref={ modalRef } className={ `_modal${ modal === 'add' || (modal === 'update' && supplier) ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            <h4>{ modal === 'add' ? 'Ajouter' : 'Modifier' } un fournisseur</h4>
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                            <form className='form' onSubmit={ handleSubmit }>
                                { errors && errors.error && <div className='alert alert-danger'>{ errors.error }</div> }
                                <div className='pb-3'>
                                    <label htmlFor='photo'>Photo ou logo</label><br/>
                                    <input ref={ fileRef } type='file' name="photo" id="photo" accept='.png,.jpeg,.jpg' onChange={ handlePhotoChange } />
                                    { (photo.length > 0 || (supplier && supplier.photo)) && <div className='pt-2'>
                                        <div className='avatar'>
                                            <img src={ photo.length ? photo : endpoint + 'storage/' + supplier.photo } alt="" />
                                        </div>
                                    </div> }
                                    { errors && errors.photo && <div className='form-error'>{ errors.photo[0] }</div> }
                                </div>
                                
                                { modal === 'update' &&
                                <div className='pb-3'>
                                    <label htmlFor='code' className='required'>Code</label>
                                    <input type='text' id='code' name='code' placeholder="Code" autoComplete='off' className='form-control' required value={ code } onChange={ (e) => setCode(e.target.value) } onBlur={ () => setIsCodeTouched(true) } />
                                    { isCodeTouched && code.length === 0 && <div className='form-error'>Veuillez saisir le code fournisseur.</div> }
                                    { isCodeTouched && code.length > 0 && /^FRN\/\d{4}\/\d{4,}$/.test(code) === false && <div className='form-error'>Le code fournisseur n'est pas valide. Le format valide est: FRN/[année]/[numérro d'ordre].</div> }
                                    { errors && errors.code && <div className='form-error'>{ errors.code[0] }</div> }
                                </div> }

                                <div className='pb-3'>
                                    <label htmlFor='type' className='required'>Type</label>
                                    <select id='type' name='type' className='form-control' required value={ type } onChange={ (e) => setType(e.target.value) } onBlur={ () => setIsTypeTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="Individual">Particulier</option>
                                        <option value="Company">Entreprise</option>
                                    </select>
                                    { isTypeTouched && type.length === 0 && <div className='form-error'>Veuillez sélectionner le type de fournisseur.</div> }
                                    { errors && errors.type && <div className='form-error'>{ errors.type[0] }</div> }
                                </div>

                                { type.length > 0 && type === 'Company' &&
                                <>
                                    <h6>Entreprise</h6>
                                    <div className='pb-3'>
                                        <label htmlFor='company_name' className={ type === 'Company' ? 'required' : '' }>Nom de l'entreprise</label>
                                        <input type='text' id='company_name' name='company_name' placeholder="Nom de l'entreprise" autoComplete='off' className='form-control' required={ type === 'Company' } value={ companyName } onChange={ (e) => setCompanyName(e.target.value) } onBlur={ () => setIsCompanyNameTouched(true) } />
                                        { isCompanyNameTouched && companyName.length === 0 && type === 'Company' && <div className='form-error'>Veuillez saisir le nom de l'entreprise.</div> }
                                        { isCompanyNameTouched && companyName.length > 0 && type === 'Company' && companyName.length < 2 && <div className='form-error'>Le nom de l'entreprise est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.company_name && <div className='form-error'>{ errors.company_name[0] }</div> }
                                    </div>
                                    <div className='row'>
                                        <div className='col-12 pb-3'>
                                            <label htmlFor='rcs'>RCS</label>
                                            <input type='text' id='rcs' name='rcs' placeholder="RCS" autoComplete='off' className='form-control' value={ rcs } onChange={ (e) => setRcs(e.target.value) } onBlur={ () => setIsRcsTouched(true) } />
                                            { isRcsTouched && rcs.length > 0 && rcs.length < 2 && <div className='form-error'>Le RCS n'est pas valide. Veuillez vérifier.</div> }
                                            { errors && errors.rcs && <div className='form-error'>{ errors.rcs[0] }</div> }
                                        </div>
                                        <div className='col-6 pb-3'>
                                            <label htmlFor='nif'>NIF</label>
                                            <input type='text' id='nif' name='nif' placeholder="NIF" autoComplete='off' className='form-control' value={ nif } onChange={ (e) => setNif(e.target.value) } onBlur={ () => setIsNifTouched(true) } />
                                            { isNifTouched && nif.length > 0 && nif.length < 2 && <div className='form-error'>Le NIF n'est pas valide. Veuillez vérifier.</div> }
                                            { errors && errors.nif && <div className='form-error'>{ errors.nif[0] }</div> }
                                        </div>
                                        <div className='col-6 pb-3'>
                                            <label htmlFor='stat'>STAT</label>
                                            <input type='text' id='stat' name='stat' placeholder="STAT" autoComplete='off' className='form-control' value={ stat } onChange={ (e) => setStat(e.target.value) } onBlur={ () => setIsStatTouched(true) } />
                                            { isStatTouched && stat.length > 0 && stat.length < 2 && <div className='form-error'>Le STAT n'est pas valide. Veuillez vérifier.</div> }
                                            { errors && errors.stat && <div className='form-error'>{ errors.stat[0] }</div> }
                                        </div>
                                    </div>
                                </> }
                                
                                { type.length > 0 && type === 'Company' && <h6>Représentant(e)</h6> }
                                <div className='pb-3'>
                                    <label htmlFor='gender' className={ type !== 'Company' ? 'required' : '' }>Civilité</label>
                                    <select id='gender' name='gender' className='form-control' required={ type !== 'Company' } value={ gender } onChange={ (e) => setGender(e.target.value) } onBlur={ () => setIsGenderTouched(true) }>
                                        <option value="">Sélectionner...</option>
                                        <option value="m">Monsieur</option>
                                        <option value="f">Madame</option>
                                    </select>
                                    { isGenderTouched && type !== 'Company' && gender.length === 0 && <div className='form-error'>Veuillez sélectionner la civilité.</div> }
                                    { errors && errors.gender && <div className='form-error'>{ errors.gender[0] }</div> }
                                </div>
                                <div className='row'>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='last_name'>Nom</label>
                                        <input type='text' id='last_name' name='last_name' placeholder='Nom' autoComplete='off' className='form-control' value={ lastname } onChange={ (e) => setLastname(e.target.value) } />
                                        { lastname.length > 0 && lastname.length < 2 && <div className='form-error'>Le nom est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.last_name && <div className='form-error'>{ errors.last_name[0] }</div> }
                                    </div>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='first_name' className={ type !== 'Company' ? 'required' : '' }>Prénom(s)</label>
                                        <input type='text' id='first_name' name='first_name' placeholder='Prénom(s)' autoComplete='off' className='form-control' required={ type !== 'Company' } value={ firstname } onChange={ (e) => setFirstname(e.target.value) } onBlur={ () => setIsFirstnameTouched(true) } />
                                        { isFirstnameTouched && firstname.length === 0 && <div className='form-error'>Veuillez saisir le prénom.</div> }
                                        { isFirstnameTouched && firstname.length > 0 && firstname.length < 2 && <div className='form-error'>Le prénom est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.first_name && <div className='form-error'>{ errors.first_name[0] }</div> }
                                    </div>
                                </div>
                                { type.length > 0 && type === 'Company' && <h6>Contacts et coordonnées</h6> }
                                <div className='pb-3'>
                                    <label htmlFor='phone'>Téléphone</label>
                                    <input type='text' id='phone' name='phone' placeholder='Téléphone' autoComplete='off' className='form-control' value={ phone } onChange={ (e) => setPhone(e.target.value) } onBlur={ () => setIsPhoneTouched(true) } />
                                    { isPhoneTouched && phone.length > 0 && /^\+?[0-9]+(\s[0-9]+)*$/.test(phone) === false && <div className='form-error'>Ce numéro de téléphone n'est pas valide.</div> }
                                    { errors && errors.phone && <div className='form-error'>{ errors.phone[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='email'>Adresse e-mail</label>
                                    <input type='email' id='email' name='email' placeholder='Adresse e-mail' autoComplete='off' className='form-control' value={ email } onChange={ (e) => setEmail(e.target.value) } onBlur={ () => setIsEmailTouched(true) } />
                                    { isEmailTouched && email.length > 0 && /^[a-z0-9-.]+@[a-z0-9-.]+\.[a-z]{2,}$/i.test(email) === false && <div className='form-error'>Cette adresse e-mail n'est pas valide.</div> }
                                    { errors && errors.email && <div className='form-error'>{ errors.email[0] }</div> }
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='address'>Adresse</label>
                                    <input type='text' id='address' name='address' placeholder='Adresse' autoComplete='off' className='form-control' value={ address } onChange={ (e) => setAddress(e.target.value) } onBlur={ () => setIsAddressTouched(true) } />
                                    { isAddressTouched && address.length > 0 && address.length < 2 && <div className='form-error'>L'adresse est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.address && <div className='form-error'>{ errors.address[0] }</div> }
                                </div>
                                <div className='row'>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='zipcode'>Code postal</label>
                                        <input type='text' id='zipcode' name='zipcode' placeholder='Code postal' autoComplete='off' className='form-control' value={ zipcode } onChange={ (e) => setZipcode(e.target.value) } onBlur={ () => setIsZipcodeTouched(true) } />
                                        { isZipcodeTouched && zipcode.length > 0 && /^\d{2,}$/.test(zipcode) === false && <div className='form-error'>Le code postal n'est pas valide.</div> }
                                        { errors && errors.zipcode && <div className='form-error'>{ errors.zipcode[0] }</div> }
                                    </div>
                                    <div className='col-6 pb-3'>
                                        <label htmlFor='city'>Ville</label>
                                        <input type='text' id='city' name='city' placeholder='Ville' autoComplete='off' className='form-control' value={ city } onChange={ (e) => setCity(e.target.value) } onBlur={ () => setIsCityTouched(true) } />
                                        { isCityTouched && city.length > 0 && city.length < 2 && <div className='form-error'>Le nom de la ville est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.city && <div className='form-error'>{ errors.city[0] }</div> }
                                    </div>
                                    <div className='col-12 pb-3'>
                                        <label htmlFor='country'>Pays</label>
                                        <input type='text' id='country' name='country' placeholder='Pays' autoComplete='off' className='form-control' value={ country } onChange={ (e) => setCountry(e.target.value) } onBlur={ () => setIsCountryTouched(true) } />
                                        { isCountryTouched && country.length > 0 && country.length < 2 && <div className='form-error'>Le nom du pays est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                        { errors && errors.country && <div className='form-error'>{ errors.country[0] }</div> }
                                    </div>
                                </div>
                                <div className='pb-3'>
                                    <label htmlFor='website'>Site internet</label>
                                    <input type='url' id='website' name='website' placeholder='Site internet' autoComplete='off' className='form-control' value={ website } onChange={ (e) => setWebsite(e.target.value) } onBlur={ () => setIsWebsiteTouched(true) } />
                                    { isWebsiteTouched && website.length > 0 && /^(https?:\/\/)?(www\.)?[a-z0-9-]+\.[a-z]{2,}.*$/.test(website) === false && <div className='form-error'>Le nom du pays est trop court. Veuillez saisir au moins 2 caractères.</div> }
                                    { errors && errors.website && <div className='form-error'>{ errors.website[0] }</div> }
                                </div>
                                <div className='pt-2 text-end'>
                                    <button type='submit' className='btn btn-lg btn-primary' disabled= {
                                        type.length === 0 || (type === 'Company' && companyName.length === 0) || (type !== 'Company' && (gender.length === 0 || firstname.length < 2)) || (lastname.length > 0 && lastname.length < 2) || (phone.length > 0 && /^\+?[0-9]+(\s[0-9]+)*$/.test(phone) === false) || (email.length > 0 && /^[a-z0-9-.]+@[a-z0-9-.]+\.[a-z]{2,}$/i.test(email) === false) || (address.length > 0 && address.length < 2) || (zipcode.length > 0 && /^\d{2,}$/.test(zipcode) === false) || (city.length > 0 && city.length < 2) || (country.length > 0 && country.length < 2) || (website.length > 0 && /^(https?:\/\/)?(www\.)?[a-z0-9-]+\.[a-z]{2,}.*$/.test(website) === false) ||
                                        (supplier && "add" === modal && type === supplier.type && companyName === supplier.company_name && (type !== 'Company' && gender === supplier.gender && firstname === supplier.first_name) && (lastname.length > 0 && lastname === supplier.last_name) && phone === supplier.phone && email === supplier.email && address === supplier.address && zipcode === supplier.zipcode && city === supplier.city && country === supplier.country && website === supplier.website)
                                    }>{ "add" === modal ? <><i className="fa fa-save"></i> Enregistrer</> : <><i className="fa fa-save"></i> Mettre à jour</> }</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div ref={ detailsModalRef } className={ `_modal${ modal === 'details' && supplier ? ' active' : '' }` }>
                    <div className='_modal-content'>
                        <div className='_modal-head'>
                            { supplier && 
                            <h4>{ supplier.code }</h4> }
                            <button className='_modal-close'>&times;</button>
                        </div>
                        <div className='_modal-body'>
                        { supplier && <>
                            <div className='mb-3'>
                                <div className='_label'>Photo</div>
                                <div className='_value'>
                                    <div className='avatar'>
                                        { supplier.photo ?
                                        <img src={ `${ endpoint }storage/${ supplier.photo }` } alt='' /> :
                                        (supplier.type === "Company" ? supplier.company_name.charAt(0) : supplier.first_name.charAt(0))
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Code</div>
                                <div className='_value'>{ supplier.code }</div>
                            </div>
                            { supplier.type === 'Company' &&
                            <>
                                <div className='mb-3'>
                                    <div className='_label'>Nom de l'entreprise</div>
                                    <div className='_value'>{ supplier.code }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>RCS</div>
                                    <div className='_value'>{ supplier.rcs }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>NIF</div>
                                    <div className='_value'>{ supplier.nif }</div>
                                </div>
                                <div className='mb-3'>
                                    <div className='_label'>STAT</div>
                                    <div className='_value'>{ supplier.stat }</div>
                                </div>
                            </> }
                            <div className='mb-3'>
                                <div className='_label'>Nom de { supplier.type === 'Company' ? 'responsable' : 'fournisseur' }</div>
                                <div className='_value'>
                                    { supplier.gender && supplier.first_name ? 
                                    <>{ supplier.gender === 'f' ? 'Madame' : 'Monsieur' } { supplier.last_name } { supplier.first_name }</> : <>Non renseigné</> }
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Adresse</div>
                                <div className='_value'>{ supplier.address && supplier.zipcode && supplier.city && supplier.country ? supplier.address + ", " + supplier.zipcode + " " + supplier.city + ", " + supplier.country : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Téléphone</div>
                                <div className='_value'>{ supplier.phone }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>E-mail</div>
                                <div className='_value'>{ supplier.email ? supplier.email : "-" }</div>
                            </div>
                            <div className='mb-3'>
                                <div className='_label'>Site web</div>
                                <div className='_value'>{ supplier.website ? supplier.website : '-' }</div>
                            </div>
                            <div className='pt-2 text-end'>
                                <button className='btn btn-lg btn-primary' onClick={ () => setModal("update") }><i className="fa fa-edit"></i> Modifier</button>
                            </div>
                        </> }
                        </div>
                    </div>
                </div>

                <div className='box'>
                    <table className='table table-striped'>
                        <thead>
                            <tr>
                                <th width="100">Code</th>
                                <th width="50px"></th>
                                <th>Entreprise</th>
                                <th>Nom et prénom</th>
                                <th>Téléphone</th>
                                <th width="75" className="text-end">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            { suppliers.loading && <tr><td colSpan={ 6 }>Chargement...</td></tr> }
                            { suppliers.loading === false && suppliers.data && suppliers.data.total === 0 && <tr><td colSpan={ 6 }>Aucun élément trouvé</td></tr> }
                            { suppliers.loading === false && suppliers.data && suppliers.data.data && suppliers.data.data.map((item, index) => {
                            return (
                            <tr key={ index }>
                                <td>{ item.code }</td>
                                <td>
                                    <div className='avatar avatar-32x32'>
                                    { item.photo ?
                                        <img src={ `${ endpoint }storage/${ item.photo }` } alt='' /> :
                                        (item.type === "Company" ? item.company_name.charAt(0) : item.first_name.charAt(0))
                                    }
                                    </div>
                                </td>
                                <td>{ item.type === 'Company' ? item.company_name : '-'}</td>
                                <td>
                                    { item.gender && item.first_name ? 
                                    <>{ item.gender === 'f' ? 'Madame' : 'Monsieur' } { item.last_name } { item.first_name }</> : <>Non renseigné</> }
                                </td>
                                <td>{ item.phone ? item.phone : 'Non renseigné' }</td>
                                <td className="text-end">
                                    <div className='actions'>
                                        <button type='button' className='toggle-action' onClick={ (e) => {
                                        e.stopPropagation();
                                        setActionModal(actionModal !== item.id ? item.id : null);
                                        } }><i className='fa fa-ellipsis-v'></i></button>
                                        <ul className={ actionModal === item.id ? 'active' : '' }>
                                            <li><button type='button' onClick={ () => {;
                                                setActionModal(null);
                                                setModal("details");
                                                setSupplier(item);
                                            } }><i className="fa fa-eye"></i> Voir les détails</button></li>
                                            <li><button type='button' onClick={ () => {
                                                setActionModal(null);
                                                setModal("update");
                                                updateSupplier(item.id);
                                            } }><i className="fa fa-edit"></i> Modifier</button></li>
                                        </ul>
                                    </div>
                                </td>
                            </tr> ) })}
                        </tbody>
                    </table>
                </div>
                
                { suppliers && suppliers.data &&
                <Paginate currentPage={ suppliers.data.current_page } totalPages={ suppliers.data.last_page } pathname={ location.pathname } search={ location.search } /> }
            </main>
        </HelmetProvider>
    )
}
